import { render } from "./AuthMediaAdd.vue?vue&type=template&id=0edc2d60"
import script from "./AuthMediaAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthMediaAdd.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/AuthMediaAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0edc2d60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0edc2d60', __exports__)) {
    api.reload('0edc2d60', __exports__)
  }
  
  module.hot.accept("./AuthMediaAdd.vue?vue&type=template&id=0edc2d60", () => {
    api.rerender('0edc2d60', render)
  })

}


export default __exports__